export enum FloatingButtonTypes {
  Groups,
  Delete,
  Unsubscribe,
  Create,
  Export,
  Select,
  Filter,
  Notification,
  ManageGroup,
  ManagePermission,
  ShowData,
  CopyIds,
  ShowOnMap,
  viewDetails,
  ManageNetworkstatus,
  UploadMovebankData,
  ActivateMovebankForwarding,
}
